// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"AnimatedParagraphs_textWrapper__TkIQg","text":"AnimatedParagraphs_text__egN9p"};